import { BUILDING_CLASS_LABELS, BUILDING_TYPE_LABELS } from 'shared/constants/buildingLabels';
import type { ISimilarBuilding } from 'shared/types/similarBuildings';
import { getUndergroundView, type IUndergroundView } from 'shared/utils/buildingMainBlock';

export interface ISimilarBuildingView {
  id: number;
  url: string | null;
  photoUrl: string | null;
  name: string;
  /** «Бизнес-центр» — перед названием */
  buildingTypeLabel: string | null;
  /** «Класс B» — после названия */
  classLabel: string | null;
  underground: IUndergroundView | null;
  address: string | null;
  representativeName: string | null;
}

/**
 * Карточка похожего здания (`OfferCard` монолита).
 * Без класса подпись не выводим: монолит в этом случае показывает пустое «Класс»
 */
export function getSimilarBuildingView(building: ISimilarBuilding): ISimilarBuildingView {
  const classLabel = building.buildingClassType ? BUILDING_CLASS_LABELS[building.buildingClassType] : undefined;

  return {
    id: building.id,
    url: building.url,
    photoUrl: building.photoUrl,
    name: building.name ?? '',
    buildingTypeLabel: (building.buildingType && BUILDING_TYPE_LABELS[building.buildingType]) || null,
    classLabel: classLabel ? `Класс ${classLabel}` : null,
    underground: building.underground?.name ? getUndergroundView(building.underground) : null,
    address: building.fullAddress,
    representativeName: building.representativeName,
  };
}
